@import (reference) '../../../../../constants/spacing.module.less';

.empty-state {
  justify-content: center;
}

.benefit-item {
  align-items: center;
}

.check-icon {
  color: var(--blue-600);
  flex-shrink: 0;
}
